import React, { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Dialog from "./Dialog";
import DialogButton from "../../assets/images/New folder/dialogButton.png";
import cp_full11 from "../../assets/images/New folder/heroBanner.png";
import ring from "../../assets/images/New folder/my_coins_frame_benefit.png";
import tabBar from "../../assets/images/New folder/notactive.png";
import rank1 from "../../assets/images/New folder/rank1.png";
import rank2 from "../../assets/images/New folder/rank2.png";
import rank3 from "../../assets/images/New folder/rank3.png";
import activeTabBar from "../../assets/images/New folder/activerBar.png";
import fallbackImage from "../../assets/icons/gift-box 1.png";
import fallbackImage1 from "../../assets/icons/selected_male.png";
import coins from "../../assets/images/New folder/ic_coin 4.png";
import rewardBgCon from "../../assets/images/New folder/rewardBgCon.png";
import { useTranslation } from "react-i18next";
import TimerComponent from "./TimerComponent";
import AutoPlayVideoWithSound from "./AutoPlayVideoWithSound";

const Design = ({
  weeklyData1,
  weeklyData2,
  rating,
  weeklyRating,
  setFlag,
  flag,
}) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [imageErrors, setImageErrors] = useState({});
  const [activeTab, setActiveTab] = useState("tab1");
  const [collectingId, setCollectingId] = useState(null);
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 375,
  );

  const { t } = useTranslation();
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get("token");
  const imageBaseUrl = "https://media.sh8afchat.com/";

  // Handle window resize
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isSmallScreen = windowWidth < 375;
  const isMediumScreen = windowWidth >= 375 && windowWidth < 414;

  const handleError = (itemId) => {
    setImageErrors((prevState) => ({
      ...prevState,
      [itemId]: true,
    }));
  };

  const handleReceived = async (id, e) => {
    if (e) e.preventDefault();
    setCollectingId(id);
    setIsLoading(true);
    try {
      const response = await fetch(
        "https://sh8afchat.com/api/charge-events/received-rewards",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            target_id: id,
          }),
        },
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      setFlag(!flag);

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error details:", error);
    } finally {
      setIsLoading(false);
      setCollectingId(null);
    }
  };

  // Enhanced ScoreBadge component
  const ScoreBadge = ({ score }) => (
    <div className="flex items-center gap-1 bg-gradient-to-r from-amber-400/30 to-yellow-600/30 backdrop-blur-sm px-2 py-1 rounded-full border border-amber-400/30">
      <img src={coins} alt="coin" className="w-4 h-4 sm:w-5 sm:h-5" />
      <span className="text-[#FCEA98] font-bold text-sm sm:text-base drop-shadow-lg">
        {parseInt(score)?.toLocaleString() || "0"}
      </span>
    </div>
  );

  // Enhanced Avatar component
  const AvatarImage = ({
    imageUrl,
    size = "w-12 h-12 sm:w-14 sm:h-14",
    className = "",
  }) => (
    <div className="relative group">
      <div className="absolute inset-0 bg-gradient-to-r from-amber-400 via-yellow-300 to-amber-400 rounded-full blur-xl opacity-75 group-hover:opacity-100 transition-opacity duration-300" />
      <div className="absolute inset-0 bg-gradient-to-r from-amber-400 to-yellow-600 rounded-full blur-sm opacity-50" />
      <img
        src={
          imageErrors[imageUrl] ? fallbackImage1 : `${imageBaseUrl}${imageUrl}`
        }
        onError={() => handleError(imageUrl)}
        className={`${size} rounded-full border-2 border-amber-400 shadow-xl relative z-10 object-cover transform group-hover:scale-110 transition-transform duration-300 ${className}`}
        alt="avatar"
      />
    </div>
  );

  // Enhanced Winner List Item
  const WinnerListItem = ({ item, position, isUser = false }) => (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: position * 0.05 }}
      whileHover={{ scale: 1.02, x: 5 }}
      className={`relative overflow-hidden rounded-2xl mb-2 ${
        isUser
          ? "bg-gradient-to-r from-amber-600/40 to-yellow-600/40 border border-amber-400/50"
          : "bg-gradient-to-r from-white/10 to-white/5 border border-white/10"
      } backdrop-blur-md shadow-lg`}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full" />

      {isUser && (
        <div className="absolute inset-0 bg-gradient-to-r from-amber-500/20 to-yellow-500/20" />
      )}

      <div className="flex items-center justify-between p-2 sm:p-3 relative z-10">
        <div className="flex items-center gap-2 sm:gap-3 flex-1">
          <span
            className={`text-amber-400 font-bold text-base sm:text-lg w-6 sm:w-8 drop-shadow-lg`}
          >
            #{position}
          </span>

          <div className="flex items-center gap-2 sm:gap-3">
            <AvatarImage
              imageUrl={item?.profile?.image || item?.avatar}
              size="w-10 h-10 sm:w-12 sm:h-12"
            />

            <div className="flex-1 min-w-0">
              <p className="text-[#FCEA98] font-bold text-xs sm:text-sm truncate max-w-[100px] sm:max-w-[150px] drop-shadow-md">
                {item?.name || item?.profile?.name}
              </p>
              <p className="text-white/90 text-xs sm:text-sm drop-shadow">
                {item?.total_charges || item?.amount} {t("coins")}
              </p>
            </div>
          </div>
        </div>

        <ScoreBadge score={item?.total_charges || item?.amount} />
      </div>
    </motion.div>
  );

  // Enhanced Reward Card Component
  const RewardCard = ({ tier, index }) => {
    const rewardsCount = tier.rewards?.length || 0;
    const showPartial = rewardsCount > 3;

    return (
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: index * 0.15 }}
        whileHover={{ scale: 1.02 }}
        className="relative mb-24 group perspective-1000"
      >
        {/* Magical glow ring */}
        <div className="absolute inset-[-10px] bg-gradient-to-r from-amber-300/30 via-yellow-300/30 to-amber-300/30 rounded-[50px] blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-700" />

        {/* Floating 3D card */}
        <motion.div className="relative transform-gpu">
          {/* Animated border gradient */}
          <div className="absolute  rounded-[40px] p-[2px]">
            <div className="absolute inset-0 bg-gradient-to-r from-amber-600/20 via-yellow-600/20 to-amber-600/20 rounded-[40px] animate-pulse" />
          </div>

          {/* Main ring with enhanced 3D effect */}
          <div className="relative transform transition-all duration-500 group-hover:scale-105 ">
            <img
              src={ring}
              alt="magical ring"
              className="w-full max-w-[500px] h-[300px] aspect-[2/1] mx-auto drop-shadow-2xl filter brightness-110"
            />

            {/* Sparkle overlay removed for performance */}

            {/* Floating value badge with enhanced animation */}
            <div className="absolute top-[5%] left-[50%] transform -translate-x-1/2 z-20">
              <div className="px-4 sm:px-5 py-1.5 rounded-full shadow-2xl backdrop-blur-sm">
                <p className="text-[#fff] text-sm sm:text-base font-bold flex items-center gap-1.5">
                  {tier.value}
                  <img src={coins} className="w-4 h-4" alt="coins" />
                </p>
              </div>
            </div>

            {/* Content container with gradient background */}
            {/* Content container with gradient background - height constrained to stay inside ring */}
            <div className="absolute h-[80%] flex flex-col bottom-[2%] top-[15%] w-full z-20 px-3">
              {/* Rewards carousel with partial visibility */}
              <div className="w-full mx-auto relative flex-1 overflow-hidden">
                <div
                  className={`flex flex-wrap gap-x-3 gap-y-4 overflow-y-auto overflow-x-hidden py-2 px-1 h-full hide-scrollbar scroll-smooth ${
                    rewardsCount <= 3 ? "justify-center" : "justify-center"
                  }`}
                  style={{
                    maskImage: showPartial
                      ? "linear-gradient(180deg, black 85%, transparent 100%)"
                      : "none",
                  }}
                >
                  {tier.rewards ? (
                    <>
                      {tier.rewards.map((item, rewardIndex) => (
                        <motion.div
                          key={rewardIndex}
                          initial={{ opacity: 0, scale: 0.8 }}
                          animate={{ opacity: 1, scale: 1 }}
                          transition={{ delay: rewardIndex * 0.1 }}
                          whileHover={{
                            scale: 1.15,
                            transition: { type: "spring", stiffness: 400 },
                          }}
                          className={`flex-shrink-0 w-[94px] mb-6 ${
                            rewardIndex === 2 && showPartial ? "opacity-70" : ""
                          }`}
                        >
                          <div
                            className="relative group/reward"
                            style={{
                              backgroundImage: `url(${rewardBgCon})`,
                              backgroundSize: "100% 100%",
                              backgroundRepeat: "no-repeat",
                              width: "93px",
                              height: "86px",
                            }}
                          >
                            {/* Magical glow on hover */}
                            <div className="absolute inset-0   rounded-xl blur-xl opacity-0 group-hover/reward:opacity-70 transition-opacity duration-300" />

                            {/* Animated border */}
                            <div
                              style={{
                                backgroundImage: rewardBgCon,
                                width: "100px",
                              }}
                              className="absolute inset-0   rounded-xl p-[2px]"
                            >
                              <div className="absolute    rounded-xl" />
                            </div>

                            {/* Card content */}
                            <div className="relative w-20 h-20 sm:w-20 sm:h-20 mx-auto  rounded-xl    flex items-center justify-center transform transition-transform  ">
                              <motion.img
                                animate={{
                                  scale: [1, 1.1, 1],
                                }}
                                transition={{
                                  duration: 3,
                                  repeat: Infinity,
                                  delay: rewardIndex * 0.2,
                                }}
                                src={
                                  imageErrors[item.image]
                                    ? fallbackImage
                                    : `${imageBaseUrl}${item.image}`
                                }
                                onError={() => handleError(item.image)}
                                className="w-16 h-16 sm:w-16 sm:h-16 object-contain filter drop-shadow-lg"
                                alt={item.name}
                              />
                            </div>

                            {/* Animated tooltip */}
                            <motion.div className=" mt-2 text-center  bg-gradient-to-r from-amber-900 to-amber-800   rounded-full text-amber-300 text-[8px]   font-medium  border border-amber-500/30 shadow-lg">
                              {item?.name}
                            </motion.div>
                          </div>
                        </motion.div>
                      ))}
                    </>
                  ) : (
                    <motion.p
                      animate={{ opacity: [0.5, 1, 0.5] }}
                      transition={{ duration: 2, repeat: Infinity }}
                      className="text-amber-300/70 text-xs font-medium text-center py-4 w-full"
                    >
                      {t("no data available")}
                    </motion.p>
                  )}
                </div>
              </div>

              {/* Enhanced action button with magical effects */}
              <div className="flex justify-center mt-2">
                {tier.is_received ? (
                  <motion.button
                    type="button"
                    whileHover={{ scale: 1.05, rotate: 1 }}
                    className="px-7 sm:px-9 py-2 sm:py-2.5 rounded-full font-bold text-gray-700 bg-gradient-to-br from-gray-400 via-gray-300 to-gray-400 border-2 border-gray-500 shadow-xl opacity-80 cursor-not-allowed relative overflow-hidden group"
                  >
                    <span className="relative z-10 flex items-center gap-2">
                      {t("Received")}
                      <span>✓</span>
                    </span>
                  </motion.button>
                ) : tier.can_received ? (
                  <motion.button
                    type="button"
                    whileHover={{ scale: 1.08, rotate: 1 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={(e) => handleReceived(tier.id, e)}
                    disabled={isLoading && collectingId === tier.id}
                    className="px-9 sm:px-11 py-2 sm:py-2.5 rounded-full font-bold text-[#421404] bg-gradient-to-r from-amber-400 via-yellow-300 to-amber-400 border-2 border-yellow-400 shadow-2xl relative overflow-hidden group"
                  >
                    <span className="relative z-10 flex items-center gap-2">
                      {isLoading && collectingId === tier.id ? (
                        <>
                          <svg
                            className="animate-spin h-4 w-4"
                            viewBox="0 0 24 24"
                          >
                            <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                              fill="none"
                            />
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            />
                          </svg>
                          {t("loading...")}
                        </>
                      ) : (
                        <>
                          <span>✨</span>
                          {t("Collect")}
                        </>
                      )}
                    </span>

                    {/* Magical shine effect */}
                    <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/40 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" />

                    {/* Sparkle effects on hover */}
                    <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      {[...Array(3)].map((_, i) => (
                        <motion.div
                          key={i}
                          animate={{
                            scale: [0, 1, 0],
                            opacity: [0, 1, 0],
                            x: [0, (i - 1) * 20],
                            y: [0, -20],
                          }}
                          transition={{
                            duration: 1,
                            repeat: Infinity,
                            delay: i * 0.2,
                          }}
                          className="absolute w-1 h-1 bg-white rounded-full"
                          style={{
                            left: `${50 + (i - 1) * 20}%`,
                            top: "50%",
                          }}
                        />
                      ))}
                    </div>
                  </motion.button>
                ) : (
                  <motion.button
                    type="button"
                    whileHover={{ scale: 1.05 }}
                    className="px-7 sm:px-9 py-2 sm:py-2.5 rounded-full font-bold text-gray-400 bg-gradient-to-br from-[#4A3A33] via-[#5F4B42] to-[#4A3A33] border-2 border-[#7A6A63] shadow-xl relative overflow-hidden group"
                  >
                    <span className="relative z-10 flex items-center gap-2">
                      <span>🔒</span>
                      {t("Locked")}
                    </span>
                  </motion.button>
                )}
              </div>
            </div>
          </div>
        </motion.div>

        {/* Magical particles removed for performance */}
      </motion.div>
    );
  };

  // Add this CSS to your global styles or component
  const styles = `
  .perspective-1000 {
    perspective: 1000px;
  }
  
  .hide-scrollbar::-webkit-scrollbar {
    display: none;
  }
  
  .hide-scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  
  .rotate-3d {
    transform-style: preserve-3d;
  }
  
  @keyframes float {
    0%, 100% { transform: translateY(0px); }
    50% { transform: translateY(-10px); }
  }
`;

  const renderTabContent = () => {
    if (activeTab === "tab1") {
      return (
        <motion.div
          key="tab1"
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -20 }}
          transition={{ duration: 0.3 }}
          className="px-3 pb-32"
        >
          {weeklyData2 ? (
            weeklyData2.map((tier, index) => (
              <RewardCard key={tier.id} tier={tier} index={index} />
            ))
          ) : (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="text-center py-12"
            >
              <p className="text-amber-300 text-sm font-medium">
                {t("no data available")}
              </p>
            </motion.div>
          )}
        </motion.div>
      );
    } else if (activeTab === "tab2") {
      return (
        <motion.div
          key="tab2"
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -20 }}
          transition={{ duration: 0.3 }}
          className="px-3 pb-32"
        >
          {/* Top winner podium */}
          {weeklyRating && weeklyRating[0] && (
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              className="relative min-h-[19rem] mb-8"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-amber-500/20 to-yellow-500/20 rounded-3xl blur-xl" />
              <img
                src={cp_full11}
                alt="background"
                className="w-full z-50 relative h-auto object-contain drop-shadow-2xl"
              />

              <div className="absolute top-8 inset-x-0 flex flex-col items-center justify-center">
                {/* Crown/Winner decoration */}
                <div className="absolute -top-8 z-20">
                  <div className="relative">
                    {/* Animated crown glow removed for performance */}
                    <div
                      className="absolute inset-0 bg-gradient-to-r from-amber-400 to-yellow-300 rounded-full blur-xl opacity-30"
                      style={{
                        width: "60px",
                        height: "60px",
                        left: "-10px",
                        top: "-10px",
                      }}
                    />
                    <div className="relative text-4xl filter drop-shadow-2xl">
                      👑
                    </div>
                  </div>
                </div>

                {/* Main avatar container with magical ring */}
                <motion.div
                  initial={{ scale: 0.8, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  transition={{ type: "spring", stiffness: 200, damping: 20 }}
                  className="relative mb-2"
                >
                  {/* Pulsing background glow removed for performance */}
                  <div className="relative z-10">
                    <div className="relative rounded-full p-1 bg-gradient-to-r from-amber-400 via-yellow-300 to-amber-400">
                      <div className="relative rounded-full overflow-hidden border-4 border-amber-400/30">
                        <AvatarImage
                          imageUrl={weeklyRating[0]?.profile?.image}
                          size="w-[8em] h-[8em] sm:w-[9em] sm:h-[9em]"
                          className="object-cover"
                        />
                      </div>
                    </div>
                  </div>
                </motion.div>

                {/* Level/rank badge */}
                <motion.div
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{ delay: 0.3, type: "spring", stiffness: 300 }}
                  className="absolute -bottom-2 -right-2 z-20"
                >
                  <div className="relative">
                    <div className="absolute inset-0 bg-gradient-to-r from-amber-400 to-yellow-300 rounded-full blur-md" />
                    <div className="relative bg-gradient-to-br from-amber-400 to-yellow-300 rounded-full w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center border-2 border-amber-200 shadow-2xl">
                      <span className="text-[#421404] font-black text-lg sm:text-xl">
                        #1
                      </span>
                    </div>
                  </div>
                </motion.div>

                {/* Name and score section with animated entrance */}
                <motion.div
                  initial={{ y: 20, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
                  className="text-center my-4 relative"
                >
                  {/* Animated background for text */}
                  <motion.div
                    animate={{
                      scale: [1, 1.02, 1],
                      opacity: [0.5, 0.8, 0.5],
                    }}
                    transition={{ duration: 3, repeat: Infinity }}
                    className="absolute inset-0 bg-gradient-to-r from-amber-500/20 via-yellow-500/20 to-amber-500/20 rounded-full blur-xl"
                  />

                  <p className="relative text-[#FCEA98] font-bold text-lg sm:text-xl drop-shadow-[0_0_10px_rgba(251,191,36,0.5)] mb-2">
                    {weeklyRating[0]?.name || "Champion"}
                  </p>

                  {/* Animated score badge */}
                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    className="relative my-3"
                  >
                    {/* Background pulse */}
                    <div className="absolute inset-0 bg-gradient-to-r from-amber-400 to-yellow-300 rounded-full blur-md opacity-30" />

                    {/* Score container */}
                    <div className="relative bg-gradient-to-r my-3 from-amber-400 via-yellow-300 to-amber-400 px-6 py-2 rounded-full border-2 border-amber-200 shadow-xl">
                      <div className="flex items-center gap-2">
                        {/* Coin icon fixed */}
                        <div>
                          <img src={coins} className="w-5 h-5" alt="coins" />
                        </div>

                        {/* Score number with counting animation */}
                        <motion.span
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1 }}
                          className="text-[#421404] font-black text-base sm:text-lg"
                        >
                          {weeklyRating[0]?.total_charges?.toLocaleString() ||
                            "0"}
                        </motion.span>
                      </div>
                    </div>
                  </motion.div>

                  {/* Achievement ribbon */}
                  <motion.div
                    initial={{ width: 0 }}
                    animate={{ width: "100%" }}
                    transition={{ delay: 0.5, duration: 0.5 }}
                    className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-3/4 h-0.5 bg-gradient-to-r from-transparent via-amber-400 to-transparent"
                  />
                </motion.div>

                {/* Floating particles removed for performance */}

                {/* Winner's spotlight effect */}
                <div className="absolute -bottom-10 left-1/2 transform -translate-x-1/2 w-32 h-8 bg-gradient-to-r from-transparent via-amber-400/10 to-transparent rounded-full blur-xl" />
              </div>
            </motion.div>
          )}

          {/* Rankings list */}
          <div className="space-y-2  ">
            {weeklyRating &&
              weeklyRating.slice(1).map((item, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: index * 0.05 }}
                  className="flex items-center gap-3 bg-gradient-to-r from-amber-950/40 to-transparent p-2 rounded-xl backdrop-blur-sm border border-amber-500/20"
                >
                  <div className="w-8 flex justify-center">
                    {index === 0 ? (
                      <motion.img
                        whileHover={{ scale: 1.2, rotate: 5 }}
                        src={rank1}
                        className="w-6"
                        alt="rank 2"
                      />
                    ) : index === 1 ? (
                      <motion.img
                        whileHover={{ scale: 1.2, rotate: 5 }}
                        src={rank2}
                        className="w-6"
                        alt="rank 3"
                      />
                    ) : index === 2 ? (
                      <motion.img
                        whileHover={{ scale: 1.2, rotate: 5 }}
                        src={rank3}
                        className="w-6"
                        alt="rank 4"
                      />
                    ) : (
                      <span className="text-amber-400 font-bold">
                        #{index + 2}
                      </span>
                    )}
                  </div>

                  <AvatarImage
                    imageUrl={item?.profile?.image}
                    size="w-10 h-10 sm:w-12 sm:h-12"
                  />

                  <div className="flex-1 flex items-center justify-between">
                    <p className="text-amber-300 font-medium text-xs sm:text-sm truncate max-w-[80px] sm:max-w-[100px]">
                      {item?.name}
                    </p>
                    <ScoreBadge score={item?.total_charges} />
                  </div>
                </motion.div>
              ))}
          </div>

          {/* Current user stats */}
          {weeklyData1?.user && (
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 20 }}
              className="fixed bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-[#381E11] via-[#381E11]/95 to-transparent backdrop-blur-sm"
            >
              <WinnerListItem
                item={{
                  ...weeklyData1.user,
                  total_charges: weeklyData1.user.amount,
                }}
                position={weeklyData1.user.rank || "—"}
                isUser={true}
              />
            </motion.div>
          )}
        </motion.div>
      );
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#381E11] via-[#2D150C] to-[#1F0E08] relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 bg-[url('/src/assets/images/New%20folder/rw%201.png')] bg-cover opacity-5" />

      {/* Gradient overlays */}
      <div className="absolute inset-0 bg-gradient-to-t from-[#381E11] via-transparent to-transparent" />
      <div className="absolute top-0 left-0 right-0 h-32 bg-gradient-to-b from-amber-500/20 to-transparent" />

      {/* Video Background with Overlay */}
      <div className=" ">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#381E11]/50 to-[#381E11] z-10" />
        <AutoPlayVideoWithSound />
      </div>

      {/* Content */}
      <div className="relative z-20">
        {/* Rules Button */}
        <AnimatePresence>
          <motion.button
            initial={{ x: 100, rotate: 10 }}
            animate={{ x: 0, rotate: 0 }}
            whileHover={{ scale: 1.1, rotate: 5 }}
            whileTap={{ scale: 0.9 }}
            type="button"
            onClick={() => setIsDialogOpen(true)}
            className="absolute -top-52 right-0 z-50"
          >
            <div className="relative">
              <img
                src={DialogButton}
                alt="rules"
                className="w-16 sm:w-20 h-auto drop-shadow-2xl"
              />
              <span className="absolute inset-0 flex items-center justify-center text-[#f5e489] font-bold text-sm sm:text-base drop-shadow-lg">
                {t("Rules")}
              </span>
            </div>
          </motion.button>
        </AnimatePresence>

        {/* Timer with glow */}
        {weeklyData1?.remainingTime && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            className="pt-4 pb-4"
          >
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-amber-400/20 to-yellow-600/20 rounded-full blur-xl" />
              <TimerComponent initialTime={weeklyData1?.remainingTime} />
            </div>
          </motion.div>
        )}

        {/* Enhanced Tabs */}
        <div className="flex justify-center gap-2 px-4 mb-6 mt-2">
          {[
            { id: "tab1", label: t("Reward") },
            { id: "tab2", label: t("Monthly") },
          ].map((tab) => (
            <motion.button
              key={tab.id}
              whileTap={{ scale: 0.95 }}
              onClick={() => setActiveTab(tab.id)}
              className="relative flex-1 max-w-[120px] group"
            >
              <motion.img
                whileHover={{ scale: 1.05 }}
                src={activeTab === tab.id ? activeTabBar : tabBar}
                alt={tab.label}
                className="w-full h-auto drop-shadow-lg"
              />
              <span
                className={`absolute inset-0 flex items-center justify-center text-sm sm:text-base font-bold ${
                  activeTab === tab.id
                    ? "text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-yellow-600 drop-shadow-lg"
                    : "text-white/60 group-hover:text-white/80 transition-colors"
                }`}
              >
                {tab.label}
              </span>
            </motion.button>
          ))}
        </div>

        {/* Tab Content */}
        <AnimatePresence mode="wait">{renderTabContent()}</AnimatePresence>
      </div>

      {/* Dialog */}
      <Dialog
        isOpen={isDialogOpen}
        closeDialog={() => setIsDialogOpen(false)}
        description={weeklyData1?.role}
      />

      {/* Global Styles */}
      <style jsx>{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }

        .custom-scrollbar::-webkit-scrollbar {
          width: 4px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.1);
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: rgba(251, 191, 36, 0.3);
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: rgba(251, 191, 36, 0.5);
        }

        @keyframes shimmer {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(100%);
          }
        }
        .animate-shimmer {
          animation: shimmer 2s infinite;
        }

        @keyframes spin-slow {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
        .animate-spin-slow {
          animation: spin-slow 3s linear infinite;
        }

        @keyframes glow {
          0%,
          100% {
            box-shadow: 0 0 20px rgba(251, 191, 36, 0.3);
          }
          50% {
            box-shadow: 0 0 40px rgba(251, 191, 36, 0.6);
          }
        }
        .animate-glow {
          animation: glow 2s infinite;
        }
      `}</style>
    </div>
  );
};

export default Design;
